var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "pad30" },
        [
          _c("h2", { staticClass: "f18 fb normal gray_2" }, [
            _vm._v("客户列表")
          ]),
          _c("div", { staticClass: "box20" }),
          _c(
            "div",
            { staticClass: "flex flex-wrap flex1 items-center mar20-b" },
            [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "w150 mar20_r",
                    attrs: { placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.customerName,
                      callback: function($$v) {
                        _vm.customerName =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "customerName"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "w150 mar20_r",
                    attrs: { placeholder: "请输入客户手机号" },
                    model: {
                      value: _vm.customerPhone,
                      callback: function($$v) {
                        _vm.customerPhone =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "customerPhone"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w150 mar20_r",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择客户分组"
                      },
                      model: {
                        value: _vm.groupId,
                        callback: function($$v) {
                          _vm.groupId = $$v
                        },
                        expression: "groupId"
                      }
                    },
                    _vm._l(_vm.groupList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      ;(_vm.customerName = ""),
                        (_vm.customerPhone = ""),
                        (_vm.groupId = "")
                    }
                  }
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.getCustomerList }
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "mar-20-l",
                  attrs: { type: "primary" },
                  on: { click: _vm.initial }
                },
                [_vm._v("新增个人客户")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "mar-15-l",
                  attrs: { type: "primary" },
                  on: { click: _vm.initialOrg }
                },
                [_vm._v("新增企业客户")]
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.customerList, "row-key": "targetId" },
              on: { "selection-change": _vm.customerSelect }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  "reserve-selection": true,
                  width: "55"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "customerName",
                  label: "客户名称"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "客户手机号" }
              }),
              _c("el-table-column", {
                attrs: { prop: "", label: "分组名称" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.groupName))]),
                          _c("i", {
                            staticClass:
                              "el-icon-edit-outline f20 mar5_r pointer",
                            on: {
                              click: function($event) {
                                ;(_vm.groupEditVisible = true),
                                  _vm.thisCheckCustomer(scope.row)
                              }
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  116899202
                )
              }),
              _c("el-table-column", {
                attrs: { label: "身份" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.type == 1
                            ? _c("span", [_vm._v("个人")])
                            : _vm._e(),
                          scope.row.type == 2
                            ? _c("span", [_vm._v("企业")])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  473686524
                )
              }),
              _c("el-table-column", {
                attrs: { label: "服务人员" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.serviceName
                            ? _c("span", [
                                _vm._v(_vm._s(scope.row.serviceName))
                              ])
                            : _c("span", [_vm._v("暂无")])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  380086195
                )
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "240" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.editCustomer(scope.row)
                                }
                              }
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "mar15-l",
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteCustomer(scope.row)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3285142889
                )
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex items-center mar20-t" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: this.multipleSelection.length == 0
                  },
                  on: { click: _vm.deleteCustomerList }
                },
                [_vm._v("删除客户 ")]
              ),
              _c("div", { staticClass: "gray9 flex-auto mar-20-l" }, [
                _vm._v(
                  "共 " +
                    _vm._s(_vm.pageTotal) +
                    " 条记录 第 " +
                    _vm._s(_vm.pageNum) +
                    " / " +
                    _vm._s(_vm.totalPage) +
                    " 页"
                )
              ]),
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next, sizes, jumper",
                  background: "",
                  "hide-on-single-page": "",
                  "page-size": _vm.pageSize,
                  "page-count": _vm.totalPage,
                  "current-page": _vm.pageNum,
                  "page-sizes": [6, 10, 20]
                },
                on: {
                  "update:pageSize": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.currentChange
                }
              })
            ],
            1
          ),
          [
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "全部分组",
                  visible: _vm.groupEditVisible,
                  width: "500px"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.groupEditVisible = $event
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "flex flex-wrap" },
                  [
                    _vm._l(_vm.groupList, function(item) {
                      return [
                        _c(
                          "div",
                          {
                            key: item.id,
                            staticClass:
                              "mar15-r mar15-b pad5-tb pad10-lr group pointer",
                            class: {
                              group_check: _vm.thisCustomer.groupId == item.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.checkGroup(item.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.name) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "flex items-center justify-center pad20-t" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.groupEditVisible = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.confirmLoading },
                        on: { click: _vm.submitGroup }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "el-dialog",
              {
                attrs: { title: "编辑客户", visible: _vm.dialogEditVisible },
                on: {
                  "update:visible": function($event) {
                    _vm.dialogEditVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  { attrs: { model: _vm.editCustomerForm } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "客户名称",
                          "label-width": _vm.formLabelWidth
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { autocomplete: "off" },
                          model: {
                            value: _vm.editCustomerForm.customerName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editCustomerForm,
                                "customerName",
                                $$v
                              )
                            },
                            expression: "editCustomerForm.customerName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "联系方式",
                          "label-width": _vm.formLabelWidth
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: true, autocomplete: "off" },
                          model: {
                            value: _vm.editCustomerForm.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.editCustomerForm, "phone", $$v)
                            },
                            expression: "editCustomerForm.phone"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "服务人员",
                          "label-width": _vm.formLabelWidth
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择服务人员"
                            },
                            model: {
                              value: _vm.editCustomerForm.serviceBoId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editCustomerForm,
                                  "serviceBoId",
                                  $$v
                                )
                              },
                              expression: "editCustomerForm.serviceBoId"
                            }
                          },
                          _vm._l(_vm.serviceList, function(item) {
                            return _c("el-option", {
                              key: item.boId,
                              attrs: {
                                label: item.boName + "-" + item.mobilePhoneCn,
                                value: item.boId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "客户分组",
                          "label-width": _vm.formLabelWidth
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "请选择客户分组"
                            },
                            model: {
                              value: _vm.editCustomerForm.groupId,
                              callback: function($$v) {
                                _vm.$set(_vm.editCustomerForm, "groupId", $$v)
                              },
                              expression: "editCustomerForm.groupId"
                            }
                          },
                          _vm._l(_vm.groupList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            ;(_vm.dialogEditVisible = false),
                              (_vm.editCustomerForm = {})
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.confirmLoading },
                        on: { click: _vm.submitCustomerForm }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "添加客户",
                  visible: _vm.dialogAddVisible,
                  width: "850px"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.dialogAddVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: { model: _vm.addCustomerForm, "label-suffix": " : " }
                  },
                  [
                    _c(
                      "el-alert",
                      {
                        attrs: {
                          title: "",
                          type: "success",
                          closable: false,
                          "show-icon": ""
                        }
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _c("div", [
                            _vm._v(
                              "温馨提示：开启自动创建客户档案功能，用户下单后自动创建客户档案 "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "pointer mar10-l fb",
                                on: { click: _vm.toShopFunction }
                              },
                              [_vm._v("去设置")]
                            )
                          ])
                        ])
                      ],
                      2
                    ),
                    _c("div", { staticClass: "box10" }),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户分组" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "请选择客户分组"
                            },
                            model: {
                              value: _vm.addCustomerForm.groupId,
                              callback: function($$v) {
                                _vm.$set(_vm.addCustomerForm, "groupId", $$v)
                              },
                              expression: "addCustomerForm.groupId"
                            }
                          },
                          _vm._l(_vm.groupList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._l(_vm.addCustomerForm.customerList, function(
                      customer,
                      index
                    ) {
                      return _c(
                        "el-form",
                        {
                          key: index,
                          staticClass: "demo-form-inline",
                          attrs: { model: customer, inline: true }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { label: "" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  maxlength: "11",
                                  placeholder: "请输入客户手机号",
                                  autocomplete: "off"
                                },
                                model: {
                                  value: customer.customerPhone,
                                  callback: function($$v) {
                                    _vm.$set(customer, "customerPhone", $$v)
                                  },
                                  expression: "customer.customerPhone"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { label: "" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入客户名称",
                                  autocomplete: "off"
                                },
                                model: {
                                  value: customer.customerName,
                                  callback: function($$v) {
                                    _vm.$set(customer, "customerName", $$v)
                                  },
                                  expression: "customer.customerName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { label: "" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择服务人员"
                                  },
                                  model: {
                                    value: customer.serviceBoId,
                                    callback: function($$v) {
                                      _vm.$set(customer, "serviceBoId", $$v)
                                    },
                                    expression: "customer.serviceBoId"
                                  }
                                },
                                _vm._l(_vm.serviceList, function(item) {
                                  return _c("el-option", {
                                    key: item.boId,
                                    attrs: {
                                      label:
                                        item.boName + "-" + item.mobilePhoneCn,
                                      value: item.boId
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c("i", {
                            staticClass:
                              "el-icon-remove f24 mar5_r pointer mar5-t",
                            on: {
                              click: function($event) {
                                return _vm.delCustomer(customer, index)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.addRow(1)
                              }
                            }
                          },
                          [_vm._v("新增")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.addRow(3)
                              }
                            }
                          },
                          [_vm._v("新增多行")]
                        )
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.dialogAddVisible = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.confirmLoading },
                        on: { click: _vm.submitCustomerFormAdd }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "添加客户",
                  visible: _vm.dialogAddOrgVisible,
                  width: "850px"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.dialogAddOrgVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: { model: _vm.addCustomerForm, "label-suffix": " : " }
                  },
                  [
                    _c(
                      "el-alert",
                      {
                        attrs: {
                          title: "",
                          type: "success",
                          closable: false,
                          "show-icon": ""
                        }
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _c("div", [
                            _vm._v(
                              "温馨提示：开启自动创建客户档案功能，用户下单后自动创建客户档案 "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "pointer mar10-l fb",
                                on: { click: _vm.toShopFunction }
                              },
                              [_vm._v("去设置")]
                            )
                          ])
                        ])
                      ],
                      2
                    ),
                    _c("div", { staticClass: "box10" }),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户分组" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "请选择客户分组"
                            },
                            model: {
                              value: _vm.addCustomerForm.groupId,
                              callback: function($$v) {
                                _vm.$set(_vm.addCustomerForm, "groupId", $$v)
                              },
                              expression: "addCustomerForm.groupId"
                            }
                          },
                          _vm._l(_vm.groupList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.addCustomerForm.customerList }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "customerName",
                            label: "企业名称"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "adminName", label: "管理员名称" }
                        }),
                        _c("el-table-column", {
                          attrs: { label: "认证状态" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.state == 8
                                      ? _c("span", [_vm._v("已认证")])
                                      : _vm._e(),
                                    scope.row.state != 8
                                      ? _c("span", [_vm._v("未认证")])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            351145808
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "服务人员" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择服务人员"
                                        },
                                        model: {
                                          value: scope.row.serviceBoId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "serviceBoId",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.serviceBoId"
                                        }
                                      },
                                      _vm._l(_vm.serviceList, function(item) {
                                        return _c("el-option", {
                                          key: item.boId,
                                          attrs: {
                                            label:
                                              item.boName +
                                              "-" +
                                              item.mobilePhoneCn,
                                            value: item.boId
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4008638354
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mar15-l",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            return _vm.delCustomer(
                                              scope.row,
                                              scope.$index
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            727996964
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "mar20-t" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                ;(_vm.dialogOrgVisible = true),
                                  (_vm.orgName = ""),
                                  (_vm.seachOrgList = [])
                              }
                            }
                          },
                          [_vm._v("新增")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "企业列表",
                          visible: _vm.dialogOrgVisible,
                          width: "700px",
                          "append-to-body": ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dialogOrgVisible = $event
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              staticClass: "w210 mar20_r",
                              attrs: { placeholder: "请输入企业全称" },
                              model: {
                                value: _vm.orgName,
                                callback: function($$v) {
                                  _vm.orgName =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "orgName"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.orgName = ""
                                  }
                                }
                              },
                              [_vm._v("重置")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "mar-15-l",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.queryOrgList()
                                  }
                                }
                              },
                              [_vm._v("查询")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.seachOrgList, "row-key": "id" },
                            on: { "selection-change": _vm.orgSelect }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                "reserve-selection": true,
                                width: "55"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                prop: "name",
                                label: "企业名称"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "adminName", label: "管理员名称" }
                            }),
                            _c("el-table-column", {
                              attrs: { label: "认证状态" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.state == 8
                                          ? _c("span", [_vm._v("已认证")])
                                          : _vm._e(),
                                        scope.row.state != 8
                                          ? _c("span", [_vm._v("未认证")])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                351145808
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", width: "100" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function($event) {
                                                return _vm.confirmOrg(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("确 定")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                996525532
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    ;(_vm.dialogOrgVisible = false),
                                      (_vm.seachOrgList = [])
                                  }
                                }
                              },
                              [_vm._v("取 消")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.confirmOrgList }
                              },
                              [_vm._v("确 定")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.dialogAddOrgVisible = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.confirmLoading },
                        on: { click: _vm.submitCustomerFormAdd }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ],
        2
      )
    : _c("div", { staticStyle: { "min-height": "900px" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }